module.exports = __webpack_public_path__ + "img/no_permission.3d1285c9.svg";